"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_edit_instructor_location_html_1 = __importDefault(require("./admin-edit-instructor-location.html"));
var admin_edit_instructor_location_controller_1 = __importDefault(require("./admin-edit-instructor-location.controller"));
var json_1 = require("../../../../common/helpers/json");
function getSchool(SchoolsModel, UserService) {
    var user = UserService.getCurrentUser();
    return SchoolsModel.getSchoolByID(user.school.id).then(function (response) {
        response.address = (0, json_1.isJson)(response.address) ? JSON.parse(response.address) : response.address;
        return response;
    });
}
getSchool.$inject = ['SchoolsModel', 'UserService'];
function getInstructor(UsersModel, $stateParams) {
    return UsersModel.getInstructorByID($stateParams.instructorId).then(function (response) {
        /* @ts-ignore */
        response.locations = response.locations.map(function (location) {
            // @ts-ignore
            location.address = (0, json_1.isJson)(location.address) ? JSON.parse(location.address) : location.address;
            return location;
        });
        return response;
    });
}
getInstructor.$inject = ['UsersModel', '$stateParams'];
function getInstructorLocations(UsersModel, $stateParams) {
    return UsersModel.getInstructorLocations($stateParams.instructorId).then(function (response) {
        var locations = response.locations.map(function (location) {
            // @ts-ignore
            location.address = (0, json_1.isJson)(location.address) ? JSON.parse(location.address) : location.address;
            return location;
        });
        return locations;
    });
}
getInstructorLocations.$inject = ['UsersModel', '$stateParams'];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider
        .state('drivecoach.admin.instructors.editlocation', {
        'url': '/:instructorId/edit-location/:locationId',
        'controller': admin_edit_instructor_location_controller_1.default,
        'controllerAs': 'vm',
        'template': admin_edit_instructor_location_html_1.default,
        'resolve': {
            'school': getSchool,
            'instructor': getInstructor,
            'instructorLocations': getInstructorLocations,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];
exports.default = angular_1.default.module('admin.dashboard.instructors.editlocation', [])
    .config(config)
    .controller('AdminInstructorEditLocation', admin_edit_instructor_location_controller_1.default);
